import React, {
  FC,
  memo,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  Fragment,
} from 'react';
import { Platform } from 'bimwin-api';
interface PitMenuRightProps {
  platform: Platform;
  properties: any;
  open?(): void;
  ref?: any;
}
const PitMenuRight: FC<PitMenuRightProps> = memo(
  forwardRef(({ platform, properties, open }, parentRef) => {
    const [menuRight, setmenuRight] = useState({
      dialog: false,
      isVisible: true,
      isShowUI: false,
      widthAndHeight: {},
    });
    const menuDataListFn = (value: any) => {
      let arr: any = menuDataList;
      arr = arr.map((item: any) => {
        if (item) {
          if (value) {
            item.id = [];
            item.disabled = false;
            item.id.push(value);
          } else {
            item.disabled = true;
          }
        }
        return item;
      });
      setmenuDataList([...arr]);
    };
    useImperativeHandle(parentRef, () => ({
      menuDataListFn: menuDataListFn,
    }));
    const [menuDataList, setmenuDataList] = useState([
      {
        title: '构件详情',
        event: '1',
        isInternal: true,
        disabled: true,
      },
      {
        title: '隐藏选中构件',
        event: '2',
        isInternal: true,
        disabled: true,
      },
      {
        title: '半透明选中构件',
        event: '3',
        isInternal: true,
        disabled: true,
      },
      {
        title: '其他构件半透明',
        event: '4',
        isInternal: true,
        disabled: true,
      },
      {
        title: '其他构件隐藏',
        event: '7',
        isInternal: true,
        disabled: true,
      },
    ]);
    useEffect(() => {
      // 鼠标右键显示菜单
      platform.bimwin.onMouseClick.add(ev => {
        if (ev.button == 2) {
          ShowContextMenu(ev);
        } else {
          CloseContextMenu();
        }
      });
    }, []);
    /** 右键菜单事件 */
    const menuRightFn = (item: any) => {
      if (!platform.bimwin) return;
      let list = platform.bimwin.getNodeHighlightSet();
      let arr: any = [];
      // 获取高亮与隐藏元素ID
      // let highlight = platform.bimwin.getNodeHighlightList();
      let hide = platform.bimwin.getNodeHideSet();
      list.forEach(element => {
        arr.push(element);
      });
      console.log(item.event);
      switch (parseInt(item.event)) {
        case 1:
          properties.value ? open && open() : null;
          break;
        case 2:
          platform.bimwin.setNodesState(arr, -1);
          break;
        case 3:
          platform.bimwin.setNodesState(arr, 2);
          break;
        case 4:
          let list: any = [];
          hide.forEach(element => {
            list.push(element);
          });
          platform.bimwin.setAllNodesState(2);
          platform.bimwin.setNodesState(arr, 1);
          platform.bimwin.setNodesState(list, -1);
          break;
        case 5:
          break;
        case 6:
          platform.bimwin.setAllNodesState(1);
          // menuDataListFn("");
          break;
        case 7:
          if (arr.length == 1) {
            platform.bimwin.setAllNodesState(-1);
            platform.bimwin.setNodesState(arr, 1);
          } else {
            platform.bimwin.setNodesVisible(arr, true);
          }
          break;
        case 8:
          item.callback({ id: arr, componentValue: properties.value });
          break;
      }
      setmenuRight(pre => {
        pre.dialog = false;
        return { ...pre };
      });
    };
    /** 显示控件右键菜单 */
    const ShowContextMenu = (e: any) => {
      if (menuRight.isVisible) {
        let target = e.currentTarget;
        let rect = target.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        setmenuRight(pre => {
          pre.dialog = true;
          pre.widthAndHeight = {
            left: x + 10 + 'px',
            top: y + 10 + 'px',
          };
          return { ...pre };
        });
      }
    };
    /** 关闭右键菜单 */
    const CloseContextMenu = () => {
      setmenuRight(pre => {
        pre.dialog = false;
        return { ...pre };
      });
    };
    const menuDataListNode = menuDataList.map((item: any, index: number) => {
      return (
        <div
          key={index}
          className={`pit-bim-win-menu-right-item ${
            item.disabled == true ? 'pit-disabled' : ''
          }`}
          onClick={() => menuRightFn(item)}
        >
          {item.title}
        </div>
      );
    });
    return (
      <Fragment>
        {menuRight.dialog ? (
          <div
            className="pit-bim-win-menu-right"
            id="menuRightId"
            v-if=""
            style={{ ...menuRight.widthAndHeight, width: '108px' }}
          >
            {menuDataListNode}

            <div
              className="pit-bim-win-menu-right-item"
              onClick={() => menuRightFn({ event: 6 })}
            >
              显示所有
            </div>
          </div>
        ) : (
          ''
        )}
      </Fragment>
    );
  })
);
export default PitMenuRight;
